<template>
  <!-- eslint-disable -->
  <div class="sidenav container d-none d-lg-block" role="navigation" aria-label="Secondary Menu">
    <div id="sidenav">
      <div class="row" v-bind:key="section.label" v-for="section in sortedSections">
        <div class="col" v-bind:data-section-name="section.label">
          <p class="mt-3 mt-md-4">{{section.label}}</p>
          <ul class="nav flex-column">
            <li class="nav-item" v-bind:key="option.name" v-for="option in section.options">
              <router-link class="nav-link" exact-active-class="active" v-bind:to="option.href">{{option.name}}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import SECTIONS from '../utils/sections';
export default {
  name: "Sidenav",
  computed: {
    sortedSections() {
      // Sort sections
      const sort = (a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        return 1;
      };
      return this.sections.map(section => {
        const options = [ ...section.options ];
        return {
          ...section,
          options: section.label === "Layout" ? options : options.sort(sort),
        };
      });
    }
  },
  data() {
    return {
      sections: [ ...SECTIONS ],
    };
  }
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
@import '../assets/scss/variables';
#sidenav {
  background-color: $white;

  @media (max-width: 767px) {
    border-top: 1px solid $gray-300;
    padding-bottom: 2.5rem;
  }
  &.collapse{
    @media (min-width: 768px) {
      display: block;
    }
  }
  p{
    font-weight: 700;
    margin-bottom: .5rem;
    font-size: 1.125rem;
  }
}
.sidenav{
  position: fixed;
  border-right: 1px solid $gray-200;
  #sidenav{
    @media (max-width: 767px) {
      padding-bottom: 1rem;
      border-bottom: 3px solid $gray-200;
    }
  }
  .menu-row{
    margin-top: 1rem;
    @media (max-width: 767px) {
      height: 50px;
      margin-top: 0;
      position: relative;
      padding-top: .25rem;
    }
  }
  .sidenav-sublabel{
    text-transform: uppercase;
    color: $primary;
    font-size: .6875rem;
    font-family: "Montserrat", sans-serif;
    font-weight: 700;
    margin-bottom: 0;
    letter-spacing: 1px;
  }
  .sidenav-label{
    font-size: 1.125rem;
    font-family: "Montserrat", sans-serif;
    font-weight: 700;
    margin-bottom: 0;
  }
  button{
    background-color: transparent;
    border-radius: 4px;
    border-color: $primary;
    position: absolute;
    right: 15px;
    top: .25rem;
    @media (min-width: 768px) {
      display: none;
    }
  }
  .menu-icon{
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    vertical-align: middle;
    content: "";
    background: no-repeat center center;
    background-size: 100% 100%;
    background-color: transparent;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$primary}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
  }
  ul{
    li{
      a{
        font-size: .875rem;
        padding: .375rem 0;
        color: $primary;
        &:hover, &:focus{
          text-decoration: none;
          font-weight: 700;
          color: $primary;
        }
        &.active{
          font-weight: 700;
          color: $primary;
        }

      }
    }
  }
}
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/Sidenav.vue